import { useSyncExternalStore } from 'react'
import { hashKey, useQueryClient, type QueryKey } from '@tanstack/react-query'

/**
 * Another component's query data as it changes, without observing the query: an observer that
 * cannot fetch (``queryFn: skipToken``) replaces the owner's fetch, and the next invalidation of
 * that query then fails instead of reading it again.
 */
export function useCachedQueryData<T>(queryKey: QueryKey): T | undefined {
  const client = useQueryClient()
  const hash = hashKey(queryKey)
  return useSyncExternalStore(
    (onChange) =>
      client.getQueryCache().subscribe((event) => {
        if (event.query.queryHash === hash) onChange()
      }),
    () => client.getQueryData<T>(queryKey),
  )
}
